// extracted by mini-css-extract-plugin
export default {"container":"AnimationBlock_container__1ZOUj","animate":"AnimationBlock_animate__dcjfz"};